import React, {Component} from 'react';
import {observable, action, makeObservable} from 'mobx';
import {observer} from 'mobx-react';

//helpers
import {styleable} from 'decorators';

//styled-components
import {VideoPlayer} from './styles';

@observer
@styleable
class VideoPlayerComponent extends Component {
  @observable isVideoHover = false;
  @observable forceControls = false;
  video = null;
  @action setVideoHover = val => (this.isVideoHover = val);
  @action setForceControls = val => (this.forceControls = val);

  constructor(props) {
    super(props);
    makeObservable(this);
  }

  componentDidMount() {
    const {autoplayVideo} = this.props;

    if (autoplayVideo) {
      this.replay();
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const {autoplayVideo: wasCurrent} = this.props;

    if (nextProps.autoplayVideo) {
      this.replay();
    } else if (wasCurrent) {
      this.video.pause();
      this.video.currentTime = 0;
    }
  }

  replay = () => {
    try {
      this.video.currentTime = 0;
      this.video.play();
      this.setForceControls(false);
    } catch (error) {
      this.setForceControls(true);
    }
  };

  render() {
    const {src, type, poster, muted} = this.props;
    return (
      <VideoPlayer
        {...((this.isVideoHover || this.forceControls) && {controls: 'controls'})}
        onMouseOver={() => this.setVideoHover(true)}
        onMouseLeave={() => this.setVideoHover(false)}
        poster={poster}
        ref={node => (this.video = node)}
        {...(muted && {muted})}
      >
        <source src={src} type={type} />
        Your browser does not support the video tag.
      </VideoPlayer>
    );
  }
}

export default VideoPlayerComponent;
